/**
 * @Description
 */
import { FC, useEffect, useState } from 'react';
import styles from '../index.module.less';
import cs from 'classnames';
import { leftListSelectionDOM } from '../../../../ts-config';
import { getBrand } from '@/common/api/recommend';
import { Checkbox, Radio, Tooltip, Typography, Form, Input } from 'antd';
import BrandBox from './BrandBox';
import IconFont from '@/common/components/IconFont';
import { leftSection, sectionKey } from '../../ts-config';
import { post } from '@/common/request';
import { useMethods } from '@lhb/hook';
import V2Form from '@/common/components/Form/V2Form';
import V2FormRangeInput from '@/common/components/Form/V2FormRangeInput/V2FormRangeInput';
import V2Empty from '@/common/components/Data/V2Empty';

const sideBoxClassName = 'sideBoxClassName';
const PLACE_CATEGORY_ID_MALL = 126; // 项目类型-商场
const SORT_RULE_SCORE = 1;// 排序规则-项目评分
const SORT_RULE_DAILY_FLOW = 2;// 排序规则-日均客流

// 选项渲染组件
const OptionRender = ({ item, checked, options, handleChecked, handleClear }) => {
  const needSearch = ['projectBrand'].includes(item?.code); // 项目品牌需要搜索
  const [keyword, setKeyword] = useState('');
  const curOptions = options?.[item?.selectionCode || item?.code]?.map(item => ({ ...item, hidden: !item.name.includes(keyword) }));
  return <div className={curOptions?.length ? styles.box : styles.boxNo} key={item?.code}>
    {/* 二级表头 */}
    {
      curOptions?.length ? <div className={styles.title} key={item?.code}>
        {item.label}
        {
          checked?.[item?.code]?.length ? <span
            onClick={() => handleClear(item?.code)}
            className={styles.clear}>清除</span> : <></>
        }
      </div> : <span key={item?.code}></span>
    }
    { needSearch && <Input className='mt-10' placeholder='请搜索' allowClear onChange={(e) => setKeyword(e.target.value)}/> }
    <Checkbox.Group
      onChange={(value) => handleChecked(value, item?.code)}
      value={checked?.[item?.code]}
      className='pl-12'
    >
      {
        curOptions?.map((option) =>
          <Checkbox
            key={option.id}
            value={option.id}
            className={styles.checkbox}
            style={{ display: option.hidden ? 'none' : '' }}
          >
            <Typography.Text className={styles.name} ellipsis={{
              // tooltip: option?.name,
              tooltip: {
                title: option?.name,
                getPopupContainer: (triggerNode: any) => triggerNode.parentNode
              }
            }}>
              {option?.name}
              {option.remark ? <Tooltip title={option.remark} trigger='hover'>
                <span className={styles.remark}>
                  <IconFont iconHref={'iconxq_ic_shuoming_normal1'} />
                </span>
              </Tooltip> : <></>}
            </Typography.Text>
          </Checkbox>
        )
      }
    </Checkbox.Group>
    {curOptions?.every(item => item.hidden) && needSearch && <V2Empty customTip='暂无数据'/> }
  </div>;
};


const SideBox: FC<{
  active,
  selectionListRef,
  setChecked,
  checked,
  cityProvinceInfo,
  setCurSelectDistrict,
  curSelectDistrict,
  districtCluster,
  options,
  setOptions,
  isSelectDistrictRef,
  firstMenuItem,
  requirementData
}> = ({
  active,
  selectionListRef,
  setChecked,
  checked,
  cityProvinceInfo,
  setCurSelectDistrict,
  curSelectDistrict,
  districtCluster,
  options,
  setOptions,
  isSelectDistrictRef,
  firstMenuItem,
  requirementData
}) => {

  const requirementId = requirementData?.requirementId; // 需求id
  const [form] = Form.useForm();
  const secondeActiveItems = firstMenuItem?.children || []; // 二级菜单列表
  const curSecondeActiveItem = secondeActiveItems?.find((selection) => selection?.code === active); // 当前选中的二级菜单
  const placeCategoryHasMall = requirementData?.placeCategoryIds?.includes(PLACE_CATEGORY_ID_MALL); // 需求的目标场景是否包含商场

  //  需求的目标场景不包含商场时选中项目客流
  useEffect(() => {
    setChecked((state) => {
      return {
        ...state,
        'sortRule': placeCategoryHasMall ? SORT_RULE_SCORE : SORT_RULE_DAILY_FLOW,
      };
    });
  }, [placeCategoryHasMall]);

  useEffect(() => {
    methods.getSession();
  }, [requirementId]);

  useEffect(() => {
    setOptions((state) => ({
      ...state,
      [sectionKey.area]: cityProvinceInfo?.children
    }));
  }, [cityProvinceInfo?.id]);

  useEffect(() => {
    const { data, isBack } = districtCluster;
    if (isBack) { // 点击了返回市级列表
      // 取消选中区
      methods.handleSelectArea([]);
      setChecked((state) => {
        return {
          ...state,
          [sectionKey.area]: [],
        };
      });
      return;
    }
    if (!data) return;
    const { districtId } = data;
    methods.handleSelectArea([districtId]);
    setChecked((state) => {
      return {
        ...state,
        [sectionKey.area]: [districtId],
      };
    });
  }, [districtCluster]);


  useEffect(() => {
    form.setFieldValue('minSpotArea', checked.minSpotArea);
    form.setFieldValue('maxSpotArea', checked.maxSpotArea);
  }, [checked.minSpotArea, checked.maxSpotArea]);

  const methods = useMethods({
    async getSession() {
      // https://yapi.lanhanba.com/project/602/interface/api/75235
      const data = await post('/map/lcn/selection', { requirementId }, { isMock: false, mockId: 602, mockSuffix: '/api' });

      if (data?.firstLevelCategory) {
        data.firstLevelCategory = data?.firstLevelCategory?.map(item => {
          return {
            id: item,
            name: item,
          };
        });
      }
      if (data?.secondLevelCategoryBusiness) {
        data.secondLevelCategoryBusiness = data?.secondLevelCategoryBusiness?.map(item => {
          return {
            id: item,
            name: item,
          };
        });
      }
      // module 1 网规相关，2行业商圈 （通用版）
      const brandData = await getBrand({ origin: 2, type: 3 });
      const options = {
        ...data,
        preferBrand: brandData,
        avoidBrand: brandData,
        caseBrand: brandData,
        tourBrand: brandData,
      };
      // setFirstLevelCategory(data?.firstLevelCategory);
      setOptions((state) => {
        return {
          ...state,
          ...options,
        };
      });
    },
    // 选择区时的公共逻辑
    handleSelectArea(value) {
      const selectDistrict:any = [];
      options?.[sectionKey.area].map((item) => {
        if (value.includes(item.id)) {
          selectDistrict.push(item);
        }
      });

      if (curSelectDistrict?.districtInfo?.length) {
        setCurSelectDistrict((state) => ({
          ...state,
          districtInfo: selectDistrict,
        }));
      } else {
        setCurSelectDistrict({
          districtInfo: selectDistrict,
          cacheMapInfo: { city: cityProvinceInfo }
        });
      }
    },
    handleChecked(value, active) {
    // console.log('active', value, active, options);
      let res = value;
      // 处理单选
      if (active === sectionKey.sortRule) {
        res = value.target.value;
      }
      // 处理选择行政区
      if (active === sectionKey.area) {
        isSelectDistrictRef.current = true;
        // 是否选择了行政区，当选择后为true,并且在5s后或切换城市后会转为false
        setTimeout(() => {
          isSelectDistrictRef.current = false;
        }, 5000);
        methods.handleSelectArea(value);
      }
      setChecked((state) => {
        return {
          ...state,
          [active]: res,
        };
      });
    },
    // // 清除
    handleClear(active) {
      if (active === sectionKey.area) {
        setCurSelectDistrict({
          districtInfo: [],
          cacheMapInfo: null
        });
      }

      setChecked((state) => {
        return {
          ...state,
          [active]: [],
        };
      });
    },
    onAreaChange() {
      console.log('change', form.getFieldsValue());
      const formData = form.getFieldsValue();
      setChecked((state) => {
        return {
          ...state,
          minSpotArea: formData.minSpotArea,
          maxSpotArea: formData.maxSpotArea,
        };
      });

    }
  });

  return active ? (
    <div
      className={cs(styles.sideBox, leftListSelectionDOM, sideBoxClassName)}
      style={{
        // 左侧的样式加了9px
        minHeight: selectionListRef.current?.clientHeight,
        height: selectionListRef.current?.clientHeight,
        maxHeight: selectionListRef.current?.clientHeight,
        right: secondeActiveItems?.length ? '-589px' : '-493px',
      }}
      key={active}
    >
      {(() => {
        const title = secondeActiveItems?.find(section => section.code === active)?.label;
        const description = secondeActiveItems?.find(section => section.code === active)?.remark;

        switch (active) {
          case 'sortRuleMenu':
            // 排名规则
            return <>
              <div className={styles.sideBoxTop}>
                <div>{leftSection.find(section => section.code === active)?.label}</div>
                <div className='mb-12 mt-4 c-999 fwNormal'>{leftSection.find(section => section.code === active)?.remark}</div>
              </div>
              <Radio.Group
                onChange={(value) => methods.handleChecked(value, sectionKey.sortRule)}
                value={checked?.[sectionKey.sortRule]}
              >
                {leftSection.find(section => section.code === active)?.modules?.map((child) => <div className={styles.box} key={child.code}>
                  <div className={styles.title} key={child.code}>
                    {child.label}
                  </div>
                  {/* 仅在需求的目标场景包含商场时展示项目评分 */}
                  { options?.[child.code]?.map((item, index) => (item.id === SORT_RULE_SCORE && !placeCategoryHasMall) ? null : <div key={index} className={styles.checkboxRadio}>
                    <Radio
                      className={styles.radio}
                      value={item.id}>
                      <Typography.Text className={styles.name} ellipsis={{
                        tooltip: {
                          title: item.name,
                          getPopupContainer: () => document.querySelector(`.${sideBoxClassName}`)
                        }
                      }}>
                        {item.name}
                      </Typography.Text>
                    </Radio>
                  </div>)}
                </div>
                )}


              </Radio.Group>
            </>;
          case sectionKey.preferBrand:
          case sectionKey.avoidBrand:
          case sectionKey.caseBrand:
          case sectionKey.tourBrand:
            // 偏好品牌、避开品牌、巡展品牌
            return <BrandBox
              key={active}
              title={title}
              description={description}
              isFuzzy={true}
              limit={[sectionKey.preferBrand, sectionKey.avoidBrand].includes(active) ? 3 : -1}
              active={active}
              checked={checked}
              handleClear={methods.handleClear}
              handleChecked={methods.handleChecked}
              options={options}
              searchParams={{ industryIds: [sectionKey.preferBrand, sectionKey.avoidBrand].includes(active) ? requirementData.industryIds : [] }}
            />;
          case 'spotArea':// 点位面积
            return <>
              <div className={styles.sideBoxTop}>
                <div>{title}</div>
                <div className='mb-12 mt-4 c-999 fwNormal'>{description}</div>
              </div>
              <div className={styles.box}>
                <div className={cs(styles.title, 'mb-12')} key={curSecondeActiveItem.code}>
                  {curSecondeActiveItem.label}
                  <span onClick={() => {
                    form.setFieldsValue({ minSpotArea: null, maxSpotArea: null });
                    methods.onAreaChange();
                  }} className={styles.clear}>清除</span>
                </div>
                <V2Form form={form}>
                  <V2FormRangeInput
                    name={['minSpotArea', 'maxSpotArea']}
                    extra='m²'
                    config={{ onChange: methods.onAreaChange }}
                    maxConfig={{
                      min: form.getFieldValue('minSpotArea')
                    }}
                    minConfig={{
                      max: form.getFieldValue('maxSpotArea')
                    }}
                  />
                </V2Form>
              </div>
            </>;
          default:
            return <>
              {/* 一级标题 */}
              <div className={styles.sideBoxTop}>
                <div>{title}</div>
                <div className='mb-12 mt-4 c-999 fwNormal'>{description}</div>
              </div>
              {/* 二级children遍历 */}
              { curSecondeActiveItem?.modules?.length
                ? curSecondeActiveItem?.modules?.map((child) => <OptionRender
                  key={child.code}
                  item={child}
                  checked={checked}
                  options={options}
                  handleChecked={methods.handleChecked}
                  handleClear={methods.handleClear} />)
                : <OptionRender
                  key={active}
                  item={curSecondeActiveItem}
                  checked={checked}
                  options={options}
                  handleChecked={methods.handleChecked}
                  handleClear={methods.handleClear}
                />
              }</>;
        }
      })()
      }
    </div>
  ) : (
    <></>
  );
};
export default SideBox;
